export const TOWER_DEFS = {
	blaster: {
		name: "Blaster",
		desc: "Fast single-target kinetic fire.",
		color: "#55d9ff",
		costs: [80, 180, 320, 540],
		damage: [9, 18, 33, 57],
		range: [120, 140, 160, 180],
		rate: [400, 350, 280, 230],
		code: "BL",
	},
	cannon: {
		name: "Cannon",
		desc: "Heavy splash volleys.",
		color: "#ff6b58",
		costs: [120, 260, 430, 680],
		damage: [22, 44, 83, 132],
		range: [100, 120, 140, 155],
		rate: [1200, 1000, 800, 700],
		splash: [40, 55, 70, 82],
		code: "CN",
	},
	sniper: {
		name: "Sniper",
		desc: "Long-range armor breaker.",
		color: "#e84dff",
		costs: [140, 300, 520, 820],
		damage: [50, 99, 176, 281],
		range: [200, 240, 280, 320],
		rate: [2000, 1800, 1500, 1250],
		code: "SN",
	},
	frost: {
		name: "Frost",
		desc: "Slows and exposes heat-shielded units.",
		color: "#7cf7d4",
		costs: [100, 220, 380, 620],
		damage: [5, 9, 16, 25],
		range: [110, 130, 150, 165],
		rate: [600, 500, 400, 340],
		slow: [0.4, 0.55, 0.7, 0.85],
		slowDur: [1500, 2000, 2500, 3000],
		code: "FR",
	},
	tesla: {
		name: "Tesla",
		desc: "Chain arcs through packed lanes.",
		color: "#f8e45c",
		costs: [160, 320, 540, 860],
		damage: [17, 33, 61, 97],
		range: [110, 130, 150, 165],
		rate: [900, 750, 600, 500],
		chains: [2, 3, 4, 5],
		code: "TS",
	},
};

export const TOWER_ORDER = ["blaster", "cannon", "sniper", "frost", "tesla"];
